const CLICK_ID_PARAMS = [
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'msclkid',
    'ttclid',
    'li_fat_id',
    'epik',
    'twclid',
    'sclid',
    'tblci',
    'ob_click_id',
    'dicbo',
    'rdt_cid',
    'aleid',
    'alart',
];

export { CLICK_ID_PARAMS };
//# sourceMappingURL=pixel-website-event.esm.js.map
